import { ApiClient, GetResponseType } from '@make-software/tg-mini-app-ui';

import { WITH_AUTH } from '@/shared';
import { GetFriendsResponseType } from '@/entities';

export const pushFriend = async (friendId: string): Promise<GetResponseType<any>> => {
  return await ApiClient.post(
    `${window.config.api_endpoint}/push-friend?friend_id=${friendId}`,
    {},
    WITH_AUTH
  );
};

export const getFriends = async (
  tgInitData?: string
): Promise<GetResponseType<GetFriendsResponseType>> => {
  return await ApiClient.get<GetFriendsResponseType>(
    `${window.config.api_endpoint}/users/me/friends`,
    tgInitData || WITH_AUTH
  );
};
